<template>
  <div class="min-height-for-section mb_controller w-100 pt-livetv bg-blur">
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="col-12">
          <div class="w-100">
            <h1>Dasar Privasi</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row mt-4 mx-1 mx-md-3">
        <div class="col-12 text-left my-2 px-0 px-md-4">
          <h1 class="mb-4">Bahasa Malaysia</h1>
          <h3>Notis Perlindungan Data Peribadi</h3>
          <p>
            (Berkuatkuasa pada: 26 Disember 2023) <br />(Terakhir dikemas kini
            pada: 02 April 2024)
          </p>
          <p class="pb-3"></p>

          <h3>PENGENALAN</h3>
          <p>
            <b>RTM</b> mengambil berat mengenai perlindungan data peribadi anda.
            Notis ini menjelaskan bagaimana <b>RTM</b> memproses data peribadi
            anda bermula daripada pengumpulan, penggunaan, perkongsian dan
            pemusnahan serta langkah keselamatan yang kami ambil untuk
            memastikan data peribadi anda dilindungi sebaiknya.
          </p>
          <p class="pb-3"></p>

          <h3>PENGUMPULAN</h3>
          <p>
            Kami mengumpul data peribadi iaitu
            <b>nama penuh, e-mel, kata laluan, jantina dan kewarganegaraan.</b>
          </p>
          <p class="pb-3"></p>

          <h3>COOKIES</h3>
          <p>
            Cookies yang dihasilkan oleh pelayan web hanya akan digunakan untuk
            mengumpul maklumat bagi mengenal pasti layaran anda yang akan
            datang.
          </p>
          <p>
            Portal RTM menggunakan <i>non-persistent cookies</i> atau
            <i>per-session cookies</i> untuk tujuan teknikal sahaja seperti
            penukaran bahasa pada Portal ini. Cookies ini tidak akan merekodkan
            data secara kekal dan ia tidak juga disimpan di dalam pemacu keras
            komputer anda. Ia akan terus di padam sebaik sahaja anda
            meninggalkan Portal ini.
          </p>
          <p class="pb-3"></p>

          <h3>SUMBER PENGUMPULAN</h3>
          <p>
            Kami mendapatkan data peribadi anda melalui pendaftaran pengguna
            melalui
            <a href="https://rtmklik.rtm.gov.my/register"
              >https://rtmklik.rtm.gov.my/register</a
            >
          </p>
          <p class="pb-3"></p>

          <h3>TUJUAN PENGUMPULAN</h3>
          <p>
            Kami mengumpul data peribadi anda untuk:
          </p>
          <ol>
            <li>
              Mempromosi bahan dan platform RTMKlik melalui hantaran notifikasi
              kepada pengguna yang berdaftar.
            </li>
            <li>
              Memantau saluran video/audio yang paling banyak ditonton/didengar
              oleh pengguna melalui sistem Content Management System (CMS).
            </li>
            <li>
              Kegunaan bahagian pemasaran RTM sebagai selling point kepada
              potential advertiser.
            </li>
          </ol>
          <p class="pb-3"></p>

          <h3>BAGAIMANA DIPROSES</h3>
          <p>
            Kami mungkin memindahkan data peribadi anda ke tempat-tempat di luar
            Malaysia termasuk jika pemindahan tersebut dibuat kepada kemudahan
            kami yang terletak di luar Malaysia atau jika mana-mana pembekal
            perkhidmatan atau rakan niaga strategik kami yang terlibat dalam
            pembekalan sebahagian daripada produk / perkhidmatan RTM.
          </p>
          <p class="pb-3"></p>

          <h3>PENZAHIRAN</h3>
          <p>
            Kami mungkin mendedahkan data peribadi anda kepada pihak ketiga
            seperti agensi penguatkuasa undang-undang, agensi badan kerajaan,
            syarikat, organisasi atau pembekal perkhidmatan yang lain.
          </p>
          <p class="pb-3"></p>

          <h3>LANGKAH KESELAMATAN</h3>
          <p>
            Kami mengambil langkah-langkah berikut untuk melindungi data
            peribadi anda:
          </p>

          <ol>
            <li>
              Memastikan data peribadi anda disimpan dengan sebaiknya mengikut
              kehendak Akta 709 (Akta Perlindungan Data Peribadi 2010)
            </li>
            <li>
              Memastikan personel kami tidak menyalahgunakan data peribadi anda
            </li>
            <li>
              Mempunyai kontrak perlindungan data peribadi dengan pihak pembekal
            </li>
          </ol>
          <p>
            Walau bagaimanapun, anda bertanggungjawab untuk mematuhi perkara
            berikut (tetapi tidak terhad kepada) bagi mengelakkan risiko
            pencerobohan terhadap data peribadi anda:
          </p>
          <ul>
            <li>
              Mencipta kata laluan yang panjang dan kukuh untuk membantu
              mencegah akses tidak sah ke komputer atau akaun peribadi;
            </li>
            <li>
              Menukar kata laluan dengan kerap boleh mengurangkan risiko untuk
              digodam;
            </li>
            <li>
              Menjaga kata laluan dengan baik dan tidak menzahirkannya kepada
              pihak lain;
            </li>
            <li>
              Mengunci komputer dengan Ctrl+Alt+Del atau kekunci Windows + L
              secara serentak;
            </li>
            <li>
              Berhati-hati dengan serangan kejuruteraan sosial yang membawa
              kepada akses tanpa kebenaran kepada sistem dan maklumat sensitif
              untuk tujuan penipuan atau jenayah.
            </li>
            <li>
              Jangan dedahkan maklumat peribadi atau kewangan dalam e-mel atau
              pesanan teks.
            </li>
          </ul>

          <p class="pb-3"></p>

          <h3>TEMPOH PENYIMPANAN</h3>
          <p>
            Data Peribadi disimpan tidak melebihi tempoh tujuh (7) tahun bagi
            yang melibatkan kewangan dan lima (5) tahun bagi yang bukan kewangan
            serta bertepatan dengan tujuan pemprosesan.
          </p>
          <p class="pb-3"></p>

          <h3>HAK ANDA</h3>
          <p>
            Anda berhak untuk:
          </p>
          <ol>
            <li>Mengakses data peribadi.</li>
            <li>Mengemaskini data peribadi.</li>
            <li>
              Menarik Balik Persetujuan / Membatal dan Memadam data peribadi.
            </li>
          </ol>
          <p class="pb-3"></p>

          <h3>PENGEMASKINIAN DASAR PRIVASI KAMI</h3>
          <p>
            Kami mungkin meminda Dasar Privasi ini dari masa ke masa dan versi
            yang dikemas kini akan digunapakai dan menggantikan mana-mana dan
            semua versi terdahulu, termasuk, versi dalam risalah atau salinan
            bercetak. Anda digalakkan untuk menyemak laman web kami dan
            mengunjungi semula Dasar Privasi ini secara berkala untuk
            mendapatkan Dasar Privasi kami yang terkini (berdasarkan tarikh
            kemas kini yang tertera di bahagian paling atas Dasar Privasi ini).
          </p>
          <p class="pb-3"></p>

          <h3>HUBUNGI KAMI</h3>
          <p>
            Anda boleh hubungi kami berkaitan data peribadi anda melalui:
            <br />
            (Jawatan) : Pegawai Perlindungan Data (DPO)
            <br />(Alamat) : Seksyen Dasar dan Penyelidikan, Tingkat 16 Menara
            Angkasapuri, Angkasapuri Kota Media <br />(No. Telefon) : 0326364197
            <br />(E-mel) : <a href="mailto:dpo@rtm.gov.my">dpo@rtm.gov.my</a>
          </p>
          <p class="pb-3"></p>

          <h3>PENGAKUAN/PERSETUJUAN MEMPROSES DATA PERIBADI</h3>
          <p>
            Saya telah membaca Notis Perlindungan Data Peribadi dan memahami
            sebab pengumpulan data peribadi saya dan cara bagaimana data itu
            boleh digunakan dan didedahkan. Saya telah diberikan salinan Notis
            Perlindungan Data Peribadi dan/atau telah dimaklumkan tentang
            perkara di dalamnya. Saya juga sedar bahawa saya boleh mengakses dan
            membetulkan data peribadi saya atas permintaan dan jika perlu. Walau
            bagaimanapun, saya faham bahawa jika dalam keadaan luar kebiasaan
            iaitu akses dinafikan untuk tujuan yang sah, sebab-sebabnya akan
            dimaklumkan kepada saya.
          </p>
          <p class="pb-3"></p>

          <h3>PENGISYTIHARAN MENGEMASKINI DATA PERIBADI</h3>
          <p>
            Saya mengesahkan bahawa maklumat yang diberikan adalah benar dan
            tepat. Saya juga faham bahawa sebarang dan/semua data peribadi yang
            telah diberikan oleh saya di dalam Profil Pengguna akan dikumpul dan
            diproses oleh pihak tuan sebagai data peribadi menurut Akta 709
            (Akta Perlindungan Data Peribadi 2010).
          </p>
          <p class="pb-3"></p>

          <!-- ENGLISH -->
          <h1 class="my-4">English</h1>
          <h3>Personal Data Protection Notice</h3>
          <p>
            (Effective date: 26 December 2023) <br />
            (Last reviewed: 02 April 2024)
          </p>
          <p class="pb-3"></p>

          <h3>INTRODUCTION</h3>
          <p>
            <b>RTM</b> care about your personal data protection. This notice
            clarifies how <b>RTM</b> processes your data from the point we
            collect, use, share, dispose of and the security measure that we
            established to ensure your personal data is well protected.
          </p>
          <p class="pb-3"></p>

          <h3>COLLECTION OF PERSONAL DATA</h3>
          <p>
            We collect your personal data which range from
            <b>full name, email, password, gender, and nationality.</b>
          </p>
          <p class="pb-3"></p>

          <h3>COOKIES</h3>
          <p>
            Cookies generated by the web server will only be used to collect
            information to identify your upcoming browser.
          </p>
          <p>
            The RTM portal uses non-persistent cookies or per-session cookies
            for technical purposes only such as language conversion on this
            Portal. These cookies will not permanently record data and they are
            not stored on your computer's hard drive. It will be removed as soon
            as you leave this portal.
          </p>
          <p class="pb-3"></p>

          <h3>SOURCE OF PERSONAL DATA COLLECTION</h3>
          <p>
            We gather your personal data from
            <a href=" https://rtmklik.rtm.gov.my/register">
              https://rtmklik.rtm.gov.my/register</a
            >
          </p>
          <p class="pb-3"></p>

          <h3>REASON FOR PERSONAL DATA COLLECTION</h3>
          <p>
            We collect your personal data to:
          </p>
          <ol>
            <li>
              Promote RTMKlik materials and platforms by sending notifications
              to registered users.
            </li>
            <li>
              Monitor most viewed audio / video channels by users through the
              Content Management System (CMS).
            </li>
            <li>
              For the RTM marketing section as a selling point to the potential
              advertiser.
            </li>
          </ol>
          <p class="pb-3"></p>

          <h3>PROCESSING OF PERSONAL DATA</h3>
          <p>
            We may transfer your personal data to places outside Malaysia
            including if the transfer is to our facilities that are located
            outside Malaysia or if any of our service providers or strategic
            partners who are involved in providing part of RTM product and/or
            service.
          </p>
          <p class="pb-3"></p>

          <h3>DISCLOSURES</h3>
          <p>
            We may disclose your personal data to the following parties: law
            enforcement agencies, government bodies and agencies, other
            companies, organisation and/or service provider.
          </p>
          <p class="pb-3"></p>

          <h3>SECURITY MEASURE</h3>
          <p>
            We take these measures to protect your personal data:
          </p>
          <ol>
            <li>
              By ensuring your personal data is kept as required by Act 709
              (Personal Data Protection Act 2010)
            </li>
            <li>By ensuring our staff not to misuse your personal data</li>
            <li>
              By performing contract / agreement with system vendor, appointed
              third party services
            </li>
          </ol>
          <p>
            However, you are responsible for complying with the following (but
            not limited to) to avoid the risk of intrusion into your personal
            data:
          </p>
          <ul>
            <li>
              Create long and strong passwords to help prevent unauthorized
              access to a computer or personal account;
            </li>
            <li>
              Changing passwords regularly can reduce the risk of being hacked;
            </li>
            <li>
              Maintain passwords well and do not disclose them to other parties;
            </li>
            <li>
              Computer locking with Ctrl+Alt+Del or Windows + L keys
              simultaneously;
            </li>
            <li>
              Beware of social engineering attacks leading to unauthorized
              access to sensitive systems and information for fraudulent or
              criminal purposes.
            </li>
            <li>
              Do not disclose personal or financial information in emails or
              text messages.
            </li>
          </ul>
          <p class="pb-3"></p>

          <h3>PERSONAL DATA RETENTION PERIOD</h3>
          <p>
            Personal Data is retained not exceeding a period of seven (7) years
            for financial and five (5) years for non-financial purposes and in
            accordance with the purposes of processing
          </p>
          <p class="pb-3"></p>

          <h3>YOUR RIGHTS</h3>
          <p>
            You have the rights to:
          </p>
          <ol>
            <li>Access to personal data.</li>
            <li>Update personal data.</li>
            <li>Withdrawal of Consent / Erasure or revoke personal data.</li>
          </ol>
          <p class="pb-3"></p>

          <h3>UPDATES TO OUR PERSONAL DATA PROTECTION NOTICE</h3>
          <p>
            We may amend this Personal Data Protection Notice from time to time
            and the updated version shall apply and supersede any and all
            previous versions, including, leaflets or hard copy versions. You
            are encouraged to check our website and re-visit this Personal Data
            Protection Notice periodically for our most up-to-date Personal Data
            Protection Notice (as reflected by the date of the update set out at
            the top of this Personal Data Protection Notice).
          </p>
          <p class="pb-3"></p>

          <h3>CONTACT US</h3>
          <p>
            You can contact us or submit your inquiry in regards to the
            processing of your personal data at: <br />
            (Designation) : Data Protection Officer (DPO)
            <br />(Address) : Seksyen Dasar dan Penyelidikan, Tingkat 16 Menara
            Angkasapuri, Angkasapuri Kota Media <br />(Telephone number):
            0326364197 <br />(Fax number / e-mail address): dpo@rtm.gov.my
          </p>
          <p class="pb-3"></p>

          <h3>DECLARATION/CONSENT FOR PROCESSING PERSONAL DATA</h3>
          <p>
            I have read the Personal Data Protection Notice and understand the
            reasons for the collection of my personal data and how the data may
            be used and disclosed. I have been provided with a copy of the
            Personal Data Protection Notice and/or have been informed of its
            contents. I am also aware that I can access and correct my personal
            data upon request and if necessary. However, I understand that if
            under exceptional circumstances, access is denied for legitimate
            purposes, the reasons will be communicated to me.
          </p>
          <p class="pb-3"></p>

          <h3>DECLARATION OF PERSONAL DATA UPDATE</h3>
          <p>
            I hereby confirm that the information provided is true and accurate.
            I also understand that any and/or all personal data provided by me
            in the User Profile will be collected and processed by the
            respective party as personal data under Act 709 (Personal Data
            Protection Act 2010).
          </p>
          <p class="pb-3"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function() {
    return {};
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 20px 0 0;
  min-height: 80vh;
}

h1 {
  font-family: Inter;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  color: #dae12f;
}
h2 {
  font-family: Sf-ui-medium;
  font-size: 22px;
  font-weight: bold;
  line-height: 1.2;
  text-align: left;
  color: #dae12f;
}
h3 {
  font-family: Inter;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.2;
  text-align: left;
  color: #dae12f;
}
h2 {
  font-family: Inter;
  font-size: 22px;
  font-weight: bold;
  line-height: 1.2;
  text-align: left;
  color: #dae12f;
}
p {
  font-family: Inter;
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #fff;
}
ul > li,
ol > li {
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #fff;
  font-family: Inter;
}
</style>
